// Turns an error from the e-Transfer recipient calls (create external account, auto-deposit check)
// into something the recipient can act on: a message on the name or email field when the error
// says which one is wrong, otherwise a banner. Returns translation keys.

export const ESCROW_ERROR_CODES = ['insufficient_escrow_balance', 'escrow_balance_error'];

// field_errors positions (PTC path) mapped to the form field they concern.
const FIELD_BY_POSITION = {
  name: 'name',
  'etransfer.name': 'name',
  'etransfer.email': 'email',
};

const FIELD_MESSAGES = {
  name: {
    required: 'interac.error.name',
    valid_external_account_name: 'interac.error.name.characters',
    valid_etransfer_name: 'interac.error.name.firstLast',
  },
  email: {
    required: 'interac.error.email',
    valid_etransfer_email: 'interac.error.email.invalid',
  },
};

// A rejection we have no specific wording for still lands on the field.
const FIELD_FALLBACK_MESSAGES = {
  name: 'interac.error.name.rejected',
  email: 'interac.error.email.rejected',
};

// invalid_parameters errors carry no field_errors, only a message.
const MESSAGE_RULES = [
  { pattern: /consecutive spaces/i, field: 'name', id: 'interac.error.name.consecutiveSpaces' },
  { pattern: /missing required fields in etransfer: name/i, field: 'name', id: 'interac.error.name' },
  { pattern: /invalid email format/i, field: 'email', id: 'interac.error.email.invalid' },
  { pattern: /phone_number or email/i, field: 'email', id: 'interac.error.email' },
];

// Our systems or the network failed; nothing the recipient typed is at fault.
const TECHNICAL_ERROR_CODES = [
  'gateway_timeout',
  'internal_error',
  'internal_server_error',
  'transitory_failure',
  'canceled',
];

export const recipientErrorFeedback = err => {
  const payload = (err && err.error) || {};
  const { code, message = '' } = payload;

  if (ESCROW_ERROR_CODES.includes(code)) {
    return { fields: {}, exception: 'insufficient_escrow' };
  }

  const fields = {};
  (Array.isArray(payload.field_errors) ? payload.field_errors : []).forEach(fieldError => {
    const position = fieldError && Array.isArray(fieldError.position) ? fieldError.position : [];
    const field = FIELD_BY_POSITION[position.join('.')];
    if (!field || fields[field]) return;
    fields[field] = FIELD_MESSAGES[field][fieldError.code] || FIELD_FALLBACK_MESSAGES[field];
  });

  if (!Object.keys(fields).length && code === 'invalid_parameters') {
    const rule = MESSAGE_RULES.find(({ pattern }) => pattern.test(message));
    if (rule) fields[rule.field] = rule.id;
  }

  if (Object.keys(fields).length) return { fields, exception: null };

  if (!code || TECHNICAL_ERROR_CODES.includes(code)) {
    return { fields: {}, exception: 'network' };
  }

  // The details were refused without saying which field, e.g. the e-Transfer processor
  // rejected them (bad_gateway).
  return { fields: {}, exception: 'details' };
};
